import lazyWithRetry from '@shared/lib/lazyWithRetry';

import Loadable from '@components/Loadable/Loadable';

const GPTChatPage = Loadable(lazyWithRetry(() => import('@pages/GPTChatPage')));

const GPTChildRoutes = {
  path: 'g',
  children: [
    {
      path: ':gpt_id',
      element: <GPTChatPage />,
    },
    {
      path: ':gpt_id/c/:chat_id',
      element: <GPTChatPage />,
    },
  ],
};

export default GPTChildRoutes;
